import React from "react";
import { Download, Share2 } from "lucide-react";
import { Button } from "components/ui/button";

const ReportDetailHeader = ({ entity }) => {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 w-full">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-foreground m-0">Institution Report Detail</h1>
        <p className="text-sm text-muted-foreground m-0 mt-1">
          {entity
            ? `Detailed metrics and benchmarking report for ${entity.name}`
            : "Select an institution to view its detailed benchmarking report"}
        </p>
      </div>

      {entity && (
        <div className="flex items-center gap-2 shrink-0">
          <Button
            variant="outline"
            size="sm"
            className="gap-2 text-slate-600 border-slate-200 hover:bg-slate-50"
            disabled
            title="Coming soon"
          >
            <Share2 size={14} />
            <span className="hidden sm:inline">Share</span>
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="gap-2 text-slate-600 border-slate-200 hover:bg-slate-50"
            disabled
            title="Coming soon"
          >
            <Download size={14} />
            <span className="hidden sm:inline">Export</span>
          </Button>
        </div>
      )}
    </div>
  );
};

export default ReportDetailHeader;
